import React from "react";

interface ISignalRMeetingsContext {
  sendRefetchTeamMeetingsList: (teamGuid: string) => void;
  sendRefetchAgendaItemContent: (agendaItemGuid: string) => void;
  sendRefetchMeetingListItem: (meetingGuid: string) => void;
  sendRefetchMeetingNotes: (meetingGuid: string) => void;
  sendRefetchMeetingParticipants: (meetingGuid: string) => void;
  sendEndMeeting: (meetingGuid: string) => void;
  onShouldRefetchAgendaItemContent: (handler: (agendaItemGuid: string) => void) => void;
  onShouldRefetchMeetingListItem: (handler: (meetingGuid: string) => void) => void;
  onShouldRefetchMeetingNotes: (handler: (meetingGuid: string) => void) => void;
  onShouldRefetchMeetingParticipants: (handler: (meetingGuid: string) => void) => void;
  onShouldRefetchTeamMeetingsList: (handler: (teamGuid: string) => void) => void;
  onShouldEndMeeting: (handler: (meetingGuid: string) => void) => void;
  offShouldRefetchAgendaItemContent: (handler: (agendaItemGuid: string) => void) => void;
  offShouldRefetchMeetingListItem: (handler: (meetingGuid: string) => void) => void;
  offShouldRefetchMeetingNotes: (handler: (meetingGuid: string) => void) => void;
  offShouldRefetchMeetingParticipants: (handler: (meetingGuid: string) => void) => void;
  offShouldRefetchTeamMeetingsList: (handler: (teamGuid: string) => void) => void;
  offShouldEndMeeting: (handler: (meetingGuid: string) => void) => void;
  onRefetchActiveMeetingNotifications: (handler: () => void) => void;
  offRefetchActiveMeetingNotifications: (handler: () => void) => void;
}

const SignalRMeetingsContext = React.createContext<ISignalRMeetingsContext>({
  sendRefetchAgendaItemContent: () => null,
  sendRefetchTeamMeetingsList: () => null,
  sendRefetchMeetingListItem: () => null,
  sendRefetchMeetingNotes: () => null,
  sendRefetchMeetingParticipants: () => null,
  sendEndMeeting: () => null,
  onShouldRefetchAgendaItemContent: () => null,
  onShouldRefetchMeetingListItem: () => null,
  onShouldRefetchMeetingNotes: () => null,
  onShouldRefetchMeetingParticipants: () => null,
  onShouldRefetchTeamMeetingsList: () => null,
  onShouldEndMeeting: () => null,
  offShouldRefetchAgendaItemContent: () => null,
  offShouldRefetchMeetingListItem: () => null,
  offShouldRefetchMeetingNotes: () => null,
  offShouldRefetchMeetingParticipants: () => null,
  offShouldRefetchTeamMeetingsList: () => null,
  offShouldEndMeeting: () => null,
  onRefetchActiveMeetingNotifications: () => null,
  offRefetchActiveMeetingNotifications: () => null,
});

export { SignalRMeetingsContext };
